import React from 'react';
import MenuItemMUI, { MenuItemProps } from '@material-ui/core/MenuItem';

export const MenuItem: React.FC<MenuItemProps> = ({ children, ...rest }) => {
	// @ts-ignore
	return <MenuItemMUI {...rest}>{children}</MenuItemMUI>;
};
